import { GiftIcon } from '../assets/icons/GiftIcon';

interface GiftMessageProps {
  message: string;
  className?: string;
}

export const GiftMessage = ({ message, className = '' }: GiftMessageProps) => {
  return (
    <div
      className={`rounded-lg flex flex-row px-3 py-2 gap-2 bg-success-600 text-neutral-0 ${className}`}
    >
      <div className="shrink-0">
        <GiftIcon size={18} color="currentColor" />
      </div>
      <span className="text-body-small-strong">{message}</span>
    </div>
  );
};
